import type { SVGProps } from 'react';
import { useId } from 'react';

export interface OfflineIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const OfflineIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: OfflineIconProps) => {
  const clipPathId = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...rest}
      width={width}
      height={height}
      className={className}
      fill="none"
      aria-hidden={true}
      focusable="false"
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
      <rect width="20" height="20" rx="10" fill="#C6C6C6" />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M14.8165 14.8165C14.6957 14.9373 14.5332 14.9998 14.3748 14.9998C14.2165 14.9998 14.054 14.9373 13.9332 14.8165L5.18315 6.06649C4.93732 5.82065 4.93732 5.42899 5.18315 5.18315C5.42899 4.93732 5.82065 4.93732 6.06649 5.18315L7.58315 6.69982C10.0248 5.75399 12.8457 6.33732 14.7123 8.19982C14.7498 8.23732 14.7873 8.27482 14.8248 8.31649C15.0623 8.56649 15.054 8.96232 14.804 9.19982C14.6832 9.31649 14.529 9.37482 14.3707 9.37482C14.204 9.37482 14.0415 9.30815 13.9165 9.18315L13.8248 9.09149C12.4415 7.70815 10.4165 7.19565 8.56649 7.69565L10.0457 9.17482C11.0207 9.19149 11.954 9.57899 12.6457 10.2707C12.8915 10.5123 12.8915 10.9123 12.6457 11.154C12.5248 11.2748 12.3665 11.3373 12.2082 11.3373L14.8082 13.9373C15.054 14.1832 15.054 14.579 14.8082 14.8207L14.8165 14.8165ZM9.99982 12.0832C9.54149 12.0832 9.16649 12.4582 9.16649 12.9165C9.16649 13.3748 9.54149 13.7498 9.99982 13.7498C10.4582 13.7498 10.8332 13.3748 10.8332 12.9165C10.8332 12.4582 10.4582 12.0832 9.99982 12.0832ZM7.49982 10.1207C7.44982 10.1665 7.39982 10.2123 7.34982 10.2623C7.10399 10.504 7.10399 10.8998 7.34982 11.1457C7.47065 11.2665 7.63315 11.329 7.79149 11.329C7.94982 11.329 8.11232 11.2665 8.23315 11.1457C8.26649 11.1123 8.29982 11.079 8.33315 11.0498C8.59149 10.8207 8.61232 10.4248 8.38315 10.1665C8.15399 9.90815 7.75815 9.88732 7.49982 10.1165V10.1207ZM5.40399 8.08732C5.36232 8.12482 5.32482 8.16232 5.28732 8.19982C5.24982 8.23732 5.21232 8.27899 5.17482 8.31649C4.93732 8.56649 4.94565 8.96232 5.19565 9.19982C5.31649 9.31649 5.47065 9.37482 5.62899 9.37482C5.79565 9.37482 5.95815 9.30815 6.08315 9.18315L6.27065 8.99565C6.52065 8.75815 6.53315 8.36232 6.29565 8.11232C6.05815 7.86232 5.66232 7.84982 5.41232 8.08732H5.40399Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default OfflineIcon;
